import { z } from 'zod';

export const GEOCODING_QUEUE_NAME = 'geocoding';

/**
 * User-Agent sent with every Nominatim request.
 * Required by the OSM Nominatim usage policy — identifies the application and
 * provides a contact address. Single source of truth shared by api and worker.
 */
export const NOMINATIM_USER_AGENT = 'OOH-Manager (administrator@gruparw.pl)';

export const GeocodingSearchQuerySchema = z.object({
  q: z.string().min(1).max(500),
});
export type GeocodingSearchQuery = z.infer<typeof GeocodingSearchQuerySchema>;

export const GeocodingSearchResponseSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  displayName: z.string(),
});
export type GeocodingSearchResponse = z.infer<typeof GeocodingSearchResponseSchema>;
